module.exports = __webpack_public_path__ + "static/media/bulbguardcam-2.002d8494.jpg";